export function href() {
  return window.location.href;
}

export function protocol() {
  return window.location.protocol;
}

export function host() {
  return window.location.host;
}

export function hostname() {
  return window.location.hostname;
}

export function port() {
  return window.location.port;
}

export function pathname() {
  return window.location.pathname;
}

export function search() {
  return window.location.search;
}

export function hash() {
  return window.location.hash;
}

export function username() {
  return window.location.username;
}

export function password() {
  return window.location.password;
}

export function origin() {
  return window.location.origin;
}

export function assign(url) {
  window.location.assign(url);
}

export function reload(url) {
  window.location.reload(url);
}

export function replace(url) {
  window.location.replace(url);
}

export function referrer() {
  return document.referrer;
}

export function open(URL, name, specs, replace) {
  return window.open(URL, name, specs, replace);
}
